import React from "react";

function PrivacyPolicy () {

    return <h3>PrivacyPolicy Under development</h3>
}

export default PrivacyPolicy;